export const matches = [
  {
    id: "m-2001",
    leagueSlug: "nba",
    leagueName: "NBA",
    home: { id: "t-lal", name: "洛杉矶湖人", shortName: "湖人", color: "#552583" },
    away: { id: "t-gsw", name: "金州勇士", shortName: "勇士", color: "#1D428A" },
    startTime: "2026-10-12T19:30:00",
    date: "2026-10-12",
    status: "live",
    homeScore: 88,
    awayScore: 84,
    venue: "斯台普斯中心 · 洛杉矶",
    stage: "常规赛 第 4 轮",
    period: "第三节 05:32",
    viewers: 128400,
    cover: "https://readdy.ai/api/search-image?query=dramatic%20indoor%20basketball%20arena%20with%20deep%20navy%20tones%20and%20orange%20spotlights%2C%20blurred%20crowd%2C%20glossy%20hardwood%20court%2C%20cinematic%20sports%20broadcast%20atmosphere&width=1600&height=900&seq=bb-live-nba-2001&orientation=landscape",
  },
  {
    id: "m-2002",
    leagueSlug: "cba",
    leagueName: "CBA",
    home: { id: "t-lng", name: "辽宁本钢", shortName: "辽宁", color: "#C8102E" },
    away: { id: "t-gdg", name: "广东华南虎", shortName: "广东", color: "#E4002B" },
    startTime: "2026-10-12T19:35:00",
    date: "2026-10-12",
    status: "live",
    homeScore: 76,
    awayScore: 79,
    venue: "辽宁体育馆 · 沈阳",
    stage: "常规赛 第 3 轮",
    period: "第四节 08:11",
    viewers: 96200,
    cover: "https://readdy.ai/api/search-image?query=packed%20indoor%20basketball%20stadium%20with%20warm%20orange%20stage%20light%20and%20blue%20accents%2C%20energetic%20chinese%20sports%20arena%2C%20motion%20blur%20crowd%2C%20cinematic&width=1600&height=900&seq=bb-live-cba-2002&orientation=landscape",
  },
  {
    id: "m-2003",
    leagueSlug: "nba",
    leagueName: "NBA",
    home: { id: "t-bos", name: "波士顿凯尔特人", shortName: "凯尔特人", color: "#007A33" },
    away: { id: "t-den", name: "丹佛掘金", shortName: "掘金", color: "#0E2240" },
    startTime: "2026-10-12T20:00:00",
    date: "2026-10-12",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    venue: "TD 花园球馆 · 波士顿",
    stage: "常规赛 第 4 轮",
    period: "未开始",
    viewers: 0,
    cover: "https://readdy.ai/api/search-image?query=empty%20modern%20basketball%20arena%20before%20tip%20off%20with%20green%20and%20white%20lighting%2C%20polished%20court%2C%20clean%20architectural%20sports%20photography&width=1600&height=900&seq=bb-up-nba-2003&orientation=landscape",
  },
  {
    id: "m-2004",
    leagueSlug: "euroleague",
    leagueName: "欧洲篮球",
    home: { id: "t-rmb", name: "皇家马德里", shortName: "皇马", color: "#FEBE10" },
    away: { id: "t-fcb", name: "巴塞罗那", shortName: "巴萨", color: "#A50044" },
    startTime: "2026-10-12T21:30:00",
    date: "2026-10-12",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    venue: "Palacio de Deportes · 马德里",
    stage: "常规赛 第 2 轮",
    period: "未开始",
    viewers: 0,
    cover: "https://readdy.ai/api/search-image?query=elegant%20european%20basketball%20hall%20with%20golden%20warm%20lighting%20and%20deep%20blue%20seats%2C%20refined%20editorial%20sports%20photography%2C%20symmetrical%20composition&width=1600&height=900&seq=bb-up-euro-2004&orientation=landscape",
  },
  {
    id: "m-2005",
    leagueSlug: "nba",
    leagueName: "NBA",
    home: { id: "t-mil", name: "密尔沃基雄鹿", shortName: "雄鹿", color: "#00471B" },
    away: { id: "t-phx", name: "菲尼克斯太阳", shortName: "太阳", color: "#1D1160" },
    startTime: "2026-10-12T22:00:00",
    date: "2026-10-12",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    venue: "论坛球馆 · 密尔沃基",
    stage: "常规赛 第 4 轮",
    period: "未开始",
    viewers: 0,
    cover: "https://readdy.ai/api/search-image?query=basketball%20arena%20at%20night%20with%20purple%20and%20dark%20green%20moody%20lighting%2C%20empty%20court%20ready%20for%20game%2C%20cinematic%20sports%20photography&width=1600&height=900&seq=bb-up-nba-2005&orientation=landscape",
  },
  {
    id: "m-2006",
    leagueSlug: "nba",
    leagueName: "NBA",
    home: { id: "t-dal", name: "达拉斯独行侠", shortName: "独行侠", color: "#00538C" },
    away: { id: "t-okc", name: "俄克拉荷马雷霆", shortName: "雷霆", color: "#007AC1" },
    startTime: "2026-10-13T08:00:00",
    date: "2026-10-13",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    venue: "美国航空中心 · 达拉斯",
    stage: "常规赛 第 5 轮",
    period: "未开始",
    viewers: 0,
    cover: "https://readdy.ai/api/search-image?query=blue%20toned%20modern%20basketball%20arena%20with%20bright%20ceiling%20lights%20and%20empty%20stands%2C%20clean%20symmetrical%20sports%20photography&width=1600&height=900&seq=bb-up-nba-2006&orientation=landscape",
  },
  {
    id: "m-2007",
    leagueSlug: "cba",
    leagueName: "CBA",
    home: { id: "t-zjd", name: "浙江稠州金租", shortName: "浙江", color: "#F26522" },
    away: { id: "t-xjy", name: "新疆伊力特", shortName: "新疆", color: "#0B5FA5" },
    startTime: "2026-10-13T19:35:00",
    date: "2026-10-13",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    venue: "杭州奥体中心 · 杭州",
    stage: "常规赛 第 4 轮",
    period: "未开始",
    viewers: 0,
    cover: "https://readdy.ai/api/search-image?query=warm%20modern%20chinese%20basketball%20arena%20with%20orange%20lighting%20and%20blue%20seat%20rows%2C%20clean%20sports%20photography%2C%20wide%20view&width=1600&height=900&seq=bb-up-cba-2007&orientation=landscape",
  },
  {
    id: "m-2008",
    leagueSlug: "euroleague",
    leagueName: "欧洲篮球",
    home: { id: "t-oly", name: "奥林匹亚科斯", shortName: "奥林匹亚科斯", color: "#C8102E" },
    away: { id: "t-fen", name: "费内巴切", shortName: "费内巴切", color: "#FFED00" },
    startTime: "2026-10-13T22:15:00",
    date: "2026-10-13",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    venue: "Peace and Friendship Stadium · 雅典",
    stage: "常规赛 第 2 轮",
    period: "未开始",
    viewers: 0,
    cover: "https://readdy.ai/api/search-image?query=mediterranean%20indoor%20basketball%20arena%20with%20red%20and%20yellow%20lighting%2C%20evening%20atmosphere%2C%20editorial%20sports%20photography%2C%20deep%20shadows&width=1600&height=900&seq=bb-up-euro-2008&orientation=landscape",
  },
  {
    id: "m-2009",
    leagueSlug: "wnba",
    leagueName: "女子篮球",
    home: { id: "t-lva", name: "拉斯维加斯王牌", shortName: "王牌", color: "#000000" },
    away: { id: "t-nyl", name: "纽约自由人", shortName: "自由人", color: "#6ECEB2" },
    startTime: "2026-10-14T09:00:00",
    date: "2026-10-14",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    venue: "Michelob ULTRA Arena · 拉斯维加斯",
    stage: "总决赛 第 2 场",
    period: "未开始",
    viewers: 0,
    cover: "https://readdy.ai/api/search-image?query=bright%20clean%20basketball%20gymnasium%20with%20teal%20and%20black%20tones%20and%20daylight%20through%20windows%2C%20fresh%20energetic%20sports%20photography&width=1600&height=900&seq=bb-up-wnba-2009&orientation=landscape",
  },
  {
    id: "m-2010",
    leagueSlug: "nba",
    leagueName: "NBA",
    home: { id: "t-nyk", name: "纽约尼克斯", shortName: "尼克斯", color: "#006BB6" },
    away: { id: "t-lal", name: "洛杉矶湖人", shortName: "湖人", color: "#552583" },
    startTime: "2026-10-14T09:30:00",
    date: "2026-10-14",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    venue: "麦迪逊广场花园 · 纽约",
    stage: "常规赛 第 5 轮",
    period: "未开始",
    viewers: 0,
    cover: "https://readdy.ai/api/search-image?query=classic%20new%20york%20basketball%20arena%20interior%20with%20warm%20amber%20lights%20and%20dark%20blue%20tones%2C%20empty%20court%2C%20cinematic%20sports%20photography&width=1600&height=900&seq=bb-up-nba-2010&orientation=landscape",
  },
  {
    id: "m-2011",
    leagueSlug: "cba",
    leagueName: "CBA",
    home: { id: "t-shj", name: "上海久事", shortName: "上海", color: "#1B3A6B" },
    away: { id: "t-bjs", name: "北京首钢", shortName: "北京", color: "#003DA5" },
    startTime: "2026-10-14T19:35:00",
    date: "2026-10-14",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    venue: "源深体育中心 · 上海",
    stage: "常规赛 第 4 轮",
    period: "未开始",
    viewers: 0,
    cover: "https://readdy.ai/api/search-image?query=urban%20modern%20basketball%20arena%20with%20deep%20blue%20lighting%20and%20bright%20scoreboard%20glow%2C%20clean%20sports%20photography&width=1600&height=900&seq=bb-up-cba-2011&orientation=landscape",
  },
  {
    id: "m-2012",
    leagueSlug: "euroleague",
    leagueName: "欧洲篮球",
    home: { id: "t-pao", name: "帕纳辛纳科斯", shortName: "帕纳辛纳科斯", color: "#0A7A3B" },
    away: { id: "t-mil2", name: "米兰阿玛尼", shortName: "米兰", color: "#C8102E" },
    startTime: "2026-10-15T20:00:00",
    date: "2026-10-15",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    venue: "OAKA · 雅典",
    stage: "常规赛 第 3 轮",
    period: "未开始",
    viewers: 0,
    cover: "https://readdy.ai/api/search-image?query=green%20toned%20european%20basketball%20arena%20with%20hanging%20lights%20and%20empty%20court%2C%20editorial%20sports%20photography%2C%20deep%20contrast&width=1600&height=900&seq=bb-up-euro-2012&orientation=landscape",
  },
  {
    id: "m-2013",
    leagueSlug: "nba",
    leagueName: "NBA",
    home: { id: "t-gsw", name: "金州勇士", shortName: "勇士", color: "#1D428A" },
    away: { id: "t-bos", name: "波士顿凯尔特人", shortName: "凯尔特人", color: "#007A33" },
    startTime: "2026-10-15T10:00:00",
    date: "2026-10-15",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    venue: "大通中心 · 旧金山",
    stage: "常规赛 第 6 轮",
    period: "未开始",
    viewers: 0,
    cover: "https://readdy.ai/api/search-image?query=modern%20bay%20area%20basketball%20arena%20with%20golden%20and%20blue%20lighting%2C%20glossy%20court%2C%20wide%20cinematic%20sports%20photography&width=1600&height=900&seq=bb-up-nba-2013&orientation=landscape",
  },
  {
    id: "m-2014",
    leagueSlug: "nba",
    leagueName: "NBA",
    home: { id: "t-den", name: "丹佛掘金", shortName: "掘金", color: "#0E2240" },
    away: { id: "t-dal", name: "达拉斯独行侠", shortName: "独行侠", color: "#00538C" },
    startTime: "2026-10-11T09:00:00",
    date: "2026-10-11",
    status: "finished",
    homeScore: 112,
    awayScore: 105,
    venue: "球场中心 · 丹佛",
    stage: "常规赛 第 3 轮",
    period: "已结束",
    viewers: 15800,
    cover: "https://readdy.ai/api/search-image?query=high%20altitude%20basketball%20arena%20with%20deep%20blue%20lighting%20and%20full%20crowd%2C%20warm%20spotlights%2C%20cinematic%20sports%20photography&width=1600&height=900&seq=bb-fin-nba-2014&orientation=landscape",
  },
  {
    id: "m-2015",
    leagueSlug: "nba",
    leagueName: "NBA",
    home: { id: "t-phx", name: "菲尼克斯太阳", shortName: "太阳", color: "#1D1160" },
    away: { id: "t-nyk", name: "纽约尼克斯", shortName: "尼克斯", color: "#006BB6" },
    startTime: "2026-10-11T11:30:00",
    date: "2026-10-11",
    status: "finished",
    homeScore: 98,
    awayScore: 103,
    venue: "足迹球馆 · 菲尼克斯",
    stage: "常规赛 第 3 轮",
    period: "已结束",
    viewers: 12400,
    cover: "https://readdy.ai/api/search-image?query=desert%20city%20basketball%20arena%20with%20purple%20and%20orange%20lighting%2C%20packed%20stands%2C%20cinematic%20sports%20photography&width=1600&height=900&seq=bb-fin-nba-2015&orientation=landscape",
  },
  {
    id: "m-2016",
    leagueSlug: "cba",
    leagueName: "CBA",
    home: { id: "t-gdg", name: "广东华南虎", shortName: "广东", color: "#E4002B" },
    away: { id: "t-zjd", name: "浙江稠州金租", shortName: "浙江", color: "#F26522" },
    startTime: "2026-10-11T19:35:00",
    date: "2026-10-11",
    status: "finished",
    homeScore: 108,
    awayScore: 99,
    venue: "东莞篮球中心 · 东莞",
    stage: "常规赛 第 3 轮",
    period: "已结束",
    viewers: 21000,
    cover: "https://readdy.ai/api/search-image?query=large%20chinese%20basketball%20arena%20with%20red%20and%20orange%20lighting%20and%20dense%20crowd%2C%20energetic%20sports%20photography&width=1600&height=900&seq=bb-fin-cba-2016&orientation=landscape",
  },
  {
    id: "m-2017",
    leagueSlug: "euroleague",
    leagueName: "欧洲篮球",
    home: { id: "t-fcb", name: "巴塞罗那", shortName: "巴萨", color: "#A50044" },
    away: { id: "t-oly", name: "奥林匹亚科斯", shortName: "奥林匹亚科斯", color: "#C8102E" },
    startTime: "2026-10-10T21:00:00",
    date: "2026-10-10",
    status: "finished",
    homeScore: 84,
    awayScore: 78,
    venue: "Palau Blaugrana · 巴塞罗那",
    stage: "常规赛 第 1 轮",
    period: "已结束",
    viewers: 9800,
    cover: "https://readdy.ai/api/search-image?query=european%20basketball%20hall%20with%20crimson%20and%20gold%20lighting%20and%20packed%20stands%2C%20editorial%20sports%20photography&width=1600&height=900&seq=bb-fin-euro-2017&orientation=landscape",
  },
  {
    id: "m-2018",
    leagueSlug: "wnba",
    leagueName: "女子篮球",
    home: { id: "t-chs", name: "芝加哥天空", shortName: "天空", color: "#418FDE" },
    away: { id: "t-cts", name: "康涅狄格太阳", shortName: "太阳", color: "#F05023" },
    startTime: "2026-10-10T08:00:00",
    date: "2026-10-10",
    status: "finished",
    homeScore: 88,
    awayScore: 92,
    venue: "Wintrust Arena · 芝加哥",
    stage: "总决赛 第 1 场",
    period: "已结束",
    viewers: 8600,
    cover: "https://readdy.ai/api/search-image?query=bright%20clean%20women%20basketball%20arena%20with%20sky%20blue%20and%20orange%20lighting%20and%20full%20crowd%2C%20fresh%20sports%20photography&width=1600&height=900&seq=bb-fin-wnba-2018&orientation=landscape",
  },
  {
    id: "m-2019",
    leagueSlug: "nba",
    leagueName: "NBA",
    home: { id: "t-mil", name: "密尔沃基雄鹿", shortName: "雄鹿", color: "#00471B" },
    away: { id: "t-okc", name: "俄克拉荷马雷霆", shortName: "雷霆", color: "#007AC1" },
    startTime: "2026-10-10T10:30:00",
    date: "2026-10-10",
    status: "finished",
    homeScore: 119,
    awayScore: 124,
    venue: "论坛球馆 · 密尔沃基",
    stage: "常规赛 第 2 轮",
    period: "已结束",
    viewers: 14200,
    cover: "https://readdy.ai/api/search-image?query=midwest%20basketball%20arena%20with%20dark%20green%20and%20blue%20lighting%2C%20packed%20crowd%2C%20cinematic%20sports%20photography&width=1600&height=900&seq=bb-fin-nba-2019&orientation=landscape",
  },
  {
    id: "m-2020",
    leagueSlug: "cba",
    leagueName: "CBA",
    home: { id: "t-bjs", name: "北京首钢", shortName: "北京", color: "#003DA5" },
    away: { id: "t-lng", name: "辽宁本钢", shortName: "辽宁", color: "#C8102E" },
    startTime: "2026-10-10T19:35:00",
    date: "2026-10-10",
    status: "finished",
    homeScore: 91,
    awayScore: 96,
    venue: "五棵松体育馆 · 北京",
    stage: "常规赛 第 2 轮",
    period: "已结束",
    viewers: 17600,
    cover: "https://readdy.ai/api/search-image?query=beijing%20basketball%20arena%20with%20blue%20and%20red%20lighting%20and%20packed%20stands%2C%20energetic%20sports%20photography&width=1600&height=900&seq=bb-fin-cba-2020&orientation=landscape",
  },
  {
    id: "m-2021",
    leagueSlug: "nba",
    leagueName: "NBA",
    home: { id: "t-okc", name: "俄克拉荷马雷霆", shortName: "雷霆", color: "#007AC1" },
    away: { id: "t-den", name: "丹佛掘金", shortName: "掘金", color: "#0E2240" },
    startTime: "2026-10-12T11:00:00",
    date: "2026-10-12",
    status: "finished",
    homeScore: 121,
    awayScore: 117,
    venue: "Paycom Center · 俄克拉荷马",
    stage: "常规赛 第 4 轮",
    period: "已结束",
    viewers: 13400,
    cover: "https://readdy.ai/api/search-image?query=sunset%20colored%20basketball%20arena%20interior%20with%20orange%20and%20blue%20lighting%2C%20packed%20crowd%2C%20cinematic%20sports%20photography&width=1600&height=900&seq=bb-fin-nba-2021&orientation=landscape",
  },
  {
    id: "m-2022",
    leagueSlug: "wnba",
    leagueName: "女子篮球",
    home: { id: "t-nyl", name: "纽约自由人", shortName: "自由人", color: "#6ECEB2" },
    away: { id: "t-lva", name: "拉斯维加斯王牌", shortName: "王牌", color: "#000000" },
    startTime: "2026-10-12T09:00:00",
    date: "2026-10-12",
    status: "finished",
    homeScore: 79,
    awayScore: 85,
    venue: "Barclays Center · 纽约",
    stage: "总决赛 第 1 场",
    period: "已结束",
    viewers: 11200,
    cover: "https://readdy.ai/api/search-image?query=brooklyn%20basketball%20arena%20with%20mint%20green%20and%20black%20lighting%2C%20full%20crowd%2C%20editorial%20sports%20photography&width=1600&height=900&seq=bb-fin-wnba-2022&orientation=landscape",
  },
];

export default matches;